import React from "react";

import "animate.css/animate.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "leaflet/dist/leaflet.css";
import { CookiesProvider } from "react-cookie";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "react-international-phone/style.css";
import { BrowserRouter } from "react-router-dom";

import { CartProvider } from "@/context/CartProvider.context";

import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <CookiesProvider>
      <BrowserRouter>
        <CartProvider>
          {/* <React.StrictMode> */}
          <App />
          {/* </React.StrictMode> */}
        </CartProvider>
      </BrowserRouter>
    </CookiesProvider>
  </HelmetProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
